import React, { useState, useEffect } from "react"
import { Row, Col, Form } from 'react-bootstrap'
import FormInput from '../../../components/FormInput'
import { connect } from 'react-redux'
import {
  updateSusceptibilityTests,
  updatePathogen,
  deleteSusceptibilityTestFromServer,
  submitChartPathogenInfo,
  setCustomSusceptibilityTestWarning,
} from '../reducers/infectionCourseFormReducer'

import {
  handleChartFieldChange,
} from '../reducers/chartFormReducer'

import SusceptibilityTestTable from './SusceptibilityTestTable'
import CustomCheckboxOptionModal from './CustomCheckboxOptionModal'
import { usePrevious } from '../../../hooks/usePrevious'

const SusceptibilityTests = (props) => {
  const [showCustomOptionModal, setShowCustomOptionModal] = useState(false)
  const [susceptibilityTestToPatch, setSusceptibilityTestToPatch] = useState(null)

  const {
    site,
    pathogen,
    handleSusceptibilityTestBlur,
    chartForReview,
    currentUser,
    primary_infection_sites,
    checkboxPatchPathogen,
    patchPathogen,
    handlePathogenBlur,
    chartDateErrorMessage,
  } = props

  let selectedDrugOption = '-'

  // HANDLING FOR 'OTHER' SUSCEPTIBILITY TESTS

  const previouslySaving = usePrevious(props.savingChartPhase)

  const checkIfSaveIsComplete = () => {
    const saving = props.savingChartPhase
    if (showCustomOptionModal && saving === false && previouslySaving === true && !props.showWarning && !props.warningMessage) {
      setShowCustomOptionModal(false)
    }
    
  }
  
  useEffect(checkIfSaveIsComplete)
  
  const handleShowCustomOptionModal = (susceptibilityTest) => {
    setShowCustomOptionModal(true)
    setSusceptibilityTestToPatch(susceptibilityTest)
  }

  const handleCancel = () => {
    setShowCustomOptionModal(false)
    setSusceptibilityTestToPatch(null)
  }

  const handleOnConfirm = (drugName) => {
    return props.addNewSusceptibilityTest(site, pathogen, drugName)
  }

  const handleOnConfirmPatch = (drugName) => {
    if (susceptibilityTestToPatch) {
      const updatedTest = { ...susceptibilityTestToPatch, drug_name: drugName }
      return handleSusceptibilityTestBlur(updatedTest, pathogen)
    }
  }

  

  // FUNCTIONS


  const handleRemoveSusceptibilityTest = (susceptibilityTest) => {
    let updatedSusceptibilityTests = props.pathogen.susceptibility_tests.filter(test => test !== susceptibilityTest)
    props.deleteSusceptibilityTestFromServer(susceptibilityTest, props)
    return props.updatePathogen(props.primary_infection_sites, props.site, props.pathogen, 'susceptibility_tests', updatedSusceptibilityTests)
  }

  const handleSaveDateOfTest = (e) => {
    props.handleChartFieldChange('chartDateErrorMessage', '')
    props.updatePathogen(props.primary_infection_sites, props.site, props.pathogen, 'date_of_test', e)

    if ((e instanceof Date && !isNaN(e)) || e === null) {
      const updatedPathogen = { ...pathogen, 'date_of_test': e }
      const pathogenInfo = {primaryInfectionSite: props.site, pathogen: updatedPathogen, key: 'date_of_test', value: e, 'chartDateErrorMessage': 'date_of_test'}
      return props.submitChartPathogenInfo(props, pathogenInfo)
    } else {
      props.updatePathogen(props.primary_infection_sites, props.site, props.pathogen, 'date_of_test', null)
    }
  }

  const getHelperText = (key) => {
    if (!props.pathogen[`${key}`]) {
      if (chartDateErrorMessage && chartDateErrorMessage !== '' && chartDateErrorMessage.includes('[')) {
        let name = chartDateErrorMessage.split('[')[1].split(']')[0]
        if (key === name || name.includes(`${key}`)) {
          return chartDateErrorMessage.split('[')[0]
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }

  const patchSusceptibilityTest = (value, fieldName, susceptibilityTest) => {
    if (susceptibilityTest) {
      return props.updateSusceptibilityTests(props.primary_infection_sites, props.site, props.pathogen, susceptibilityTest, fieldName, value)
    }
  }

  const handleSelect = (e) => {
    const { value } = e.target

    selectedDrugOption = '-'
    if (value && value.toLowerCase() === 'other') {
      return setShowCustomOptionModal(true)
    }
    return props.addNewSusceptibilityTest(site, pathogen, value)
  }

  const getSusceptibilityTestDrugsForDropdown = () => {
    //this function looks at the existing susceptibility test instances in the db and removes them from the dropdown if they are already previously created.
    //the only exception to the above rule, is other. Other will always appear as an option and will create a free text field
    let tests = susceptibilityDrugOptions
    pathogen.susceptibility_tests.forEach(test => {
      if (tests.includes(test.drug_name)) {
        if (test.drug_name !== 'Other') {
          tests = tests.filter(t => t !== test.drug_name)
        }
      }
    })
    return tests.map(choice => {
      return (
        <option
          key={choice}
          value={choice}
        >
          {choice}
        </option>
      )
    })
  }

  const handleRapidTestMethodChange = (bool) => {
    const updatedPathogen = {
      ...props.pathogen,
      rapid_test_method_description: '',
    }
    checkboxPatchPathogen(bool, props.site, updatedPathogen, 'rapid_test_method_used')
  }

  const susceptibilityDrugOptions = [
    'Cefiderocol',
    'Amikacin',
    'Ampicillin/Sulbactam',
    'Aztreonam',
    'Cefepime',
    'Cefotaxime',
    'Ceftazidime',
    'Ceftazidime/Avibactam',
    'Ceftolozane/Tazobactam',
    'Ciprofloxacin',
    'Co-amoxiclav',
    'Colistin',
    'Delafloxacin',
    'Eravacycline',
    'Ertapenem',
    'Gentamicin',
    'Imipenem',
    'Imipenem/Relebactam',
    'Levofloxacin',
    'Meropenem',
    'Piperacillin-tazobactam',
    'Plazomicin',
    'Tigecycline',
    'Trimethoprim / Sulfamethoxazole',
  ]

  const interpretationOptions = [
    {value: 'S',
    fieldName: 'susceptibile'},
    {value: 'I',
    fieldName: 'intermediate'},
    {value: 'R',
    fieldName: 'resistant'},
    {value: 'NI',
    fieldName: 'not_interpretable'},
  ]

  const micOrZoneOptions = [
    {displayName: 'MIC',
    fieldName: 'mic'},
    {displayName: 'Zone size',
    fieldName: 'zone'},
  ]

  const pathogenRadioIdName = `${props.pathogen.primary_infection_site}-${props.pathogen.name.split(' ').join('')}-${props.pathogen.id}`
  
  return (
    <div className="indented-row">

      {showCustomOptionModal && !chartForReview ?
        <CustomCheckboxOptionModal
          show={showCustomOptionModal}
          modelName='Susceptibility Test'
          onCancel={handleCancel}
          headerText="Add Other Susceptibility Test"
          showAlertMessage={props.showWarning}
          toggleAlertMessage={(message) => props.setCustomSusceptibilityTestWarning(message)}
          alertMessage={props.warningMessage}
          bodyText="Enter a drug name for the susceptibility test"
          formValue={susceptibilityTestToPatch ? susceptibilityTestToPatch.drug_name : ''}
          formPlaceholder="Enter drug name"
          onConfirm={(drugName) => handleOnConfirm(drugName)}
          onConfirmPatch={(updatedDrugName) => handleOnConfirmPatch(updatedDrugName)}
          onConfirmMethod={susceptibilityTestToPatch ? 'PATCH' : 'POST'}
          disabled={chartForReview}
        />
        :
        null
      }

      <p>Please answer the following questions about the susceptibility tests administered for {pathogen.name}. Use the dropdown below to add the drugs tested:</p>
      <FormInput
        label={'Date when the susceptibility test against this Gram-negative pathogen was reported to the hospital'}
        name={'date_of_test'}
        value={pathogen.date_of_test}
        type={'date'}
        xs={12}
        sm={12}
        md={8}
        lg={6}
        onChange={handleSaveDateOfTest}
        disabled={chartForReview}
        required={true}
        errorText={getHelperText('date_of_test')}
      />

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <SusceptibilityTestTable
            primary_infection_sites={primary_infection_sites}
            pathogen={pathogen}
            site={site}
            handleRemoveSusceptibilityTest={handleRemoveSusceptibilityTest}
            susceptibilityDrugOptions={susceptibilityDrugOptions}
            chartForReview={chartForReview}
            patchSusceptibilityTest={patchSusceptibilityTest}
            handleSusceptibilityTestBlur={handleSusceptibilityTestBlur}
            interpretationOptions={interpretationOptions}
            micOrZoneOptions={micOrZoneOptions}
            currentUser={currentUser}
            updateSusceptibilityTests={updateSusceptibilityTests}
            savingChartPhase={props.savingChartPhase}
            handleShowCustomOptionModal={handleShowCustomOptionModal}

          />

          {props.chartForReview ?
            null
            :
            <Row>
              <Col xs={12} sm={12} md={6} lg={6}>
                <Form.Control
                  as="select"
                  className="centered-dropdown"
                  value={selectedDrugOption}
                  onChange={handleSelect}
                  isValid={false}
                  isInvalid={false}
                >
                  <option value={"-"}>
                    Add Susceptibility Test
                  </option>
                  {getSusceptibilityTestDrugsForDropdown()}
                  <option value={'Other'}> Other</option>
               </Form.Control>
              </Col>
            </Row>
          }

          {//getRapidTestQuestion()
          }

            <Form.Label>
              Was a rapid test method used for detecting carbapenem resistance?
            </Form.Label>
            <Form.Check
              id={`${pathogenRadioIdName}-rapidTestMethodNotUsed`}
              type="radio"
              name={`${pathogenRadioIdName}-rapidTestMethodNotUsed`}
              label={'No'}
              checked={pathogen.rapid_test_method_used === false}
              value={'No'}
              onChange={() => handleRapidTestMethodChange(false)}
            />
            <Form.Check
              id={`${pathogenRadioIdName}-rapidTestMethodUsed`}
              type="radio"
              name={`${pathogenRadioIdName}-rapidTestMethodUsed`}
              label={'Yes'}
              checked={pathogen.rapid_test_method_used === true}
              value={'Yes'}
              onChange={() => handleRapidTestMethodChange(true)}
            />

          {
            pathogen.rapid_test_method_used
            ?
              <div className="indented-row">
                <FormInput
                  label={'What was the test method?'}
                  name={'rapid_test_method_description'}
                  value={pathogen.rapid_test_method_description}
                  type={'text'}
                  placeholder={'Enter the rapid test method used'}
                  xs={12}
                  sm={12}
                  md={8}
                  lg={6}
                  onChange={(e, site, pathogen, name) => patchPathogen(e, props.site, props.pathogen, 'rapid_test_method_description')}
                  onBlur={() => handlePathogenBlur(props.site, props.pathogen)}
                  disabled={chartForReview}
                  required={true}
                />
              </div>
            :
            null
          }

        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    primary_infection_sites: state.infectionCourseFormReducer.primary_infection_sites,
    currentUser: state.loginReducer.currentUser,
    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
    savingChartPhase: state.chartFormReducer.savingChartPhase,
    showWarning: state.infectionCourseFormReducer.showCustomSusceptibilityTestWarning,
    warningMessage: state.infectionCourseFormReducer.customSusceptibilityTestWarningMessage,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateSusceptibilityTests: (primaryInfectionSites, primaryInfectionSiteId, pathogenId, susceptibilityTestId, name, selection) => dispatch(updateSusceptibilityTests(primaryInfectionSites, primaryInfectionSiteId, pathogenId, susceptibilityTestId, name, selection)),
    updatePathogen: (primaryInfectionSites, primaryInfectionSite, pathogen, name, selection) => dispatch(updatePathogen(primaryInfectionSites, primaryInfectionSite, pathogen, name, selection)),
    deleteSusceptibilityTestFromServer: (susceptibilityTestToRemove, props) => dispatch(deleteSusceptibilityTestFromServer(susceptibilityTestToRemove, props)),
    submitChartPathogenInfo: (props, pathogenInfo) => dispatch(submitChartPathogenInfo(props, pathogenInfo)),
    handleChartFieldChange: (key, value) => dispatch(handleChartFieldChange(key, value)),
    setCustomSusceptibilityTestWarning: (message) => dispatch(setCustomSusceptibilityTestWarning(message)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SusceptibilityTests)
